export enum MessageErrorEnum {
    FileUploadError = "The file was not uploaded. Please try again",
    MessageSendingError = "Message not sent"
}
